import styled from 'styled-components';

const BORDER = '#2e2e32';
const SURFACE = '#18181b';
const MUTED = '#a1a1aa';
const TEXT = '#fafafa';

export const ResultContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: calc(100% - 32px);
	max-width: 560px;
	margin: 16px auto;
	padding: 16px;
	background: ${SURFACE};
	border: 1px solid ${BORDER};
	border-radius: 12px;
	color: ${TEXT};
	box-sizing: border-box;
`;

export const Status = styled.div<{ $error: boolean }>`
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 16px;
	border-radius: 8px;
	background: ${({ $error }) => ($error ? '#dc2626' : '#16a34a')};
	color: #ffffff;
`;

export const StatusIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 44px;
	height: 44px;
	border-radius: 50%;
	border: 2px solid #ffffff;
`;

export const StatusText = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 0;
`;

export const Title = styled.h2`
	margin: 0;
	font-size: 20px;
	font-weight: 700;
	line-height: 1.2;
	color: inherit;
`;

export const Subtitle = styled.span`
	font-size: 14px;
	opacity: 0.9;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const TicketCard = styled.div`
	display: flex;
	border: 1px solid ${BORDER};
	border-radius: 8px;
	overflow: hidden;
	background: #111113;
`;

export const TypeBand = styled.div<{ $color: string }>`
	flex-shrink: 0;
	width: 10px;
	background: ${({ $color }) => $color};
`;

export const TicketBody = styled.div`
	flex: 1;
	min-width: 0;
	padding: 14px 16px;
`;

export const TicketType = styled.h3`
	margin: 0;
	font-size: 20px;
	font-weight: 700;
	line-height: 1.25;
	color: ${TEXT};
`;

export const ColorName = styled.span`
	display: block;
	margin-top: 2px;
	font-size: 13px;
	color: ${MUTED};
`;

export const Rows = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 12px;
	border-top: 1px solid ${BORDER};
`;

export const Row = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	gap: 12px;
	padding: 10px 0;
	border-bottom: 1px solid ${BORDER};
	font-size: 15px;

	&:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}

	span {
		color: ${MUTED};
		flex-shrink: 0;
	}

	strong {
		font-weight: 600;
		color: ${TEXT};
		text-align: right;
		word-break: break-word;
	}
`;

export const Mono = styled.code`
	font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
	font-size: 13px;
	color: ${MUTED};
	text-align: right;
`;

export const Loading = styled.div`
	padding: 16px;
	border: 1px solid ${BORDER};
	border-radius: 8px;
	color: ${MUTED};
	font-size: 14px;
`;

export const FanNotes = styled.div`
	padding: 12px 14px;
	border: 1px solid #a16207;
	border-radius: 8px;
	background: #1c1708;
`;

export const FanNotesTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	font-weight: 600;
	color: #fbbf24;
`;

export const FanNoteItem = styled.p`
	margin: 8px 0 0;
	font-size: 15px;
	color: ${TEXT};
	white-space: pre-wrap;
	word-break: break-word;
`;

export const Actions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const ActionBase = styled.button`
	width: 100%;
	min-height: 52px;
	padding: 0 16px;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;

	&:disabled {
		opacity: 0.6;
		cursor: default;
	}
`;

export const PrimaryAction = styled(ActionBase)`
	border: 1px solid ${TEXT};
	background: ${TEXT};
	color: #09090b;
`;

export const SecondaryAction = styled(ActionBase)<{ $armed?: boolean }>`
	border: 1px solid ${({ $armed }) => ($armed ? '#f87171' : BORDER)};
	background: ${({ $armed }) => ($armed ? '#2a1212' : 'transparent')};
	color: ${({ $armed }) => ($armed ? '#fca5a5' : TEXT)};
`;

export const Note = styled.p<{ $error?: boolean }>`
	margin: 0;
	font-size: 14px;
	text-align: center;
	color: ${({ $error }) => ($error ? '#f87171' : '#4ade80')};
`;
